export const onBoarding = {
    welcomeMessage: 'ONBOARDING.WELCOME_MESSAGE',
    description: 'ONBOARDING.DESCRIPTION',
    timeMessage: 'ONBOARDING.TIME_MESSAGE',
    addWorkspace: 'ONBOARDING.ADD_WORKSPACE',
    addWorkspaceLogo: 'ADD_WORKSPACE_LOGO',
    addYourOrganization: 'ONBOARDING.ADD_YOUR_ORGANIZATION',
    suggestions: 'ONBOARDING.SUGGESTIONS',
    workspaceNameAvailable: 'ONBOARDING.AVAILABLE',
    workspaceNameNotAvailable: 'ONBOARDING.NOT_AVAILABLE',
    privacyFriendly: 'ONBOARDING.PRIVACY_FRIENDLY',
    addNowButton: 'ONBOARDING.BUTTON.ADD_NOW',
    fillOrganizationName: 'ONBOARDING.ERROR.FILL_ORGANIZATION_NAME',
    fillHandleName: 'ONBOARDING.ERROR.FILL_HANDLE_NAME',
    spaceNotAllowed: 'ONBOARDING.ERROR.SPACE_NOT_ALLOWED',
    allowedCharacters: 'ONBOARDING.ERROR.ALLOWED_CHARACTERS',
    handleNameAlreadyTaken: 'ONBOARDING.ERROR.HANDLE_NAME_ALREADY_TAKEN',
    useSmallCase: 'ONBOARDING.USE_SMALLCASE'
};
